import { ReportData } from "../store/types";
import request from "@/request";

export const msgReport = (dataToSend: ReportData[], reportUrl: string) => {
  return request.post<boolean>(reportUrl, {
    logList: dataToSend.map(
      (item) =>
        `${item.traceId}/${item.scene}/${item.t}/${item.extra?.toString()}`,
    ),
  });
};
